<fin-seat-map-view
  [flight]="flight"
  [passengers$]="passengers$"
  [seatSelections$]="seatSelections$"
  [flightIsActive$]="flightIsActive$"
  [includedSeats]="includedSeats"
  [availability$]="availability$"
  [cartOrOrder$]="cartOrOrder$"
  [canClearSeats]="canClearSeats"
  [preSelectedPax$]="preSelectedPax$"
  [ancillaryLoader$]="ancillaryLoader$"
  [skipScroll]="skipScroll"
  [notEligibleWhenCheckInClosed]="notEligibleWhenCheckInClosed"
  (retrySeatmap)="retrySeatmap.emit(flight)"
  (changeSeats)="seatSelected($event)"
  (isReassigningSeats)="emitFinishedReassigningSeats()"
>
</fin-seat-map-view>
